import React, { useState, useEffect, useContext } from "react";
import ClinicalAuditReviewForm from "../components/Audit/ClinicalAuditReviewForm";
import { ApiCall } from "../utility/ApiCalls";
import Box from "@mui/system/Box";
import UserContext from "../components/Common/UserContext";
import Api_Call from "../ApiCall";
import menus from "../user-config.json";

function ClinicalAudit() {
  const [data, setData] = useState([]);
  const { userRole: user } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  async function getAuditData(e) {
    console.log("Inside getValidatedTask API call ");
    console.log(sessionStorage.getItem("ActiveTaskID"));
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `AUDIT/DATA?taskID=${sessionStorage.getItem(
          "ActiveTaskID"
        )}&user_type=${user}&clinical_data=${
          menus[user.toLowerCase()]["clinical"]
        }`
      );
      const repsonse = data.body;
      console.log(repsonse);
      console.log(
        "setting state ===================================================== "
      );
      console.log(data.body);

      setData(data.body);

      return repsonse;
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
    // const ret = await ApiCall(
    //   {
    //     taskID: sessionStorage.getItem("ActiveTaskID"),
    //     // taskID: "110003",
    //     clinical_data: "0",
    //     user_type: user,
    //   },
    //   "vcare-ui",
    //   "vcareui_clinicalaudit"
    // );
    // const repsonse = ret.body;
    // console.log(
    //   "setting state ===================================================== "
    // );
    // console.log(ret.body);

    // setData(ret.body);
    // setLoading(false);

    // return repsonse;
  }
  useEffect(() => {
    getAuditData();
  }, []);

  if (loading) {
    return (
      <div>
        <Box className="loader-wrapper">
          <div className="loader"></div>
        </Box>
      </div>
    );
  } else {
    return <ClinicalAuditReviewForm data={data} />;
  }
}

export default ClinicalAudit;
